import React, { useEffect, useRef } from 'react';
import './Map.scss';
import PropTypes from 'prop-types';
import { select } from 'd3-selection';

import colors from '../../../../../../../../apps/baykis-pl/pattern-lab/_data/generated-colors.json';
import {
  createContourLayerOnChart,
  createDataLayerOnChart,
  mapDataToShape,
} from './MapUtlitiy';

const Map = ({ size, shapePath, shape, data, latLonData, colorConfig }) => {
  Map.propTypes = {
    size: PropTypes.number,
    shapePath: PropTypes.func.isRequired,
    data: PropTypes.array.isRequired,
    colorConfig: PropTypes.object.isRequired,
    latLonData: PropTypes.array.isRequired,
  };

  Map.defaultProps = {
    size: 240,
  };

  const svgPadding = 5;

  const { colorScale } = colorConfig;

  const mapContainer = useRef(null);

  const drawMap = (mapData) => {
    const mapContainerD3 = select(mapContainer.current);
    let svg = mapContainerD3?.select('svg');
    if (svg.empty()) {
      svg = mapContainerD3
        .append('svg')
        .attr('xmlns', 'http://www.w3.org/2000/svg')
        .attr('viewBox', `0 0 ${size} ${size}`);
    } else {
      svg.selectAll('g').remove();
    }

    // Order determines zIndex -> last drawn = on top
    const defs = svg.append('defs');
    const pixelG = svg.append('g');
    const contourG = svg.append('g');

    createDataLayerOnChart(mapData, colorScale, pixelG, svgPadding, shapePath);
    createContourLayerOnChart(
      shape,
      shapePath,
      defs,
      contourG,
      colors,
      svgPadding,
      shapePath
    );
  };

  useEffect(() => {
    const mapDataShape = mapDataToShape(data, latLonData);
    drawMap(mapDataShape);
  }, [data, drawMap, latLonData]);

  return <div className="canvas-wrapper" ref={mapContainer} />;
};

export default React.memo(Map);
